import React, { useEffect, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Menu from "../ui/Menu";
import { pubCall } from "../utils/PubSub";
import { ROUTES } from "../utils/Routes";
import { createScreen } from "../hooks/createScreen";
import { createModal } from "../hooks/createModal";
import { kbdEvent, runEvent } from "../utils/Utils";
import { showError, showMessage } from "../ui/Message";
import GlobalDiscount from "./GlobalDiscount";

export default function CategoryExtra (props) {

    const { controller = "" , callback = () => { }, route = "", signal ={} } = props;

    const menu = [
        { text: "Global discount changes", key: KBD.A, option: "A", action: () => selectOption("A") },
        { text: "Create Classes.csv file for import into Edelweiss", key: KBD.B, option: "B", action: () => selectOption("B") },
    ]

    const [selected, setSelected] = useState("A");

    const selectOption = (option) => {

        if (option === "A") {
            window.bm_state.value = ROUTES.ORDERS.EXTRA_DISCOUNT;
            createModal({
                title: "Change discounts",
                component: <GlobalDiscount controller={controller} route={ROUTES.ORDERS.EXTRA_DISCOUNT} signal={signal} />,
                closable: true,
                callback: (option) => {
                    if (option) {
                        callback(true);
                    } else {
                        window.bm_state.value = route;
                    }
                }
            })


        } else if (option === "B") {
            pubCall("category.exportToCsv", {}, (_s, _r) => {
                if (_s) {
                    showMessage("Classes.csv file created successfully");
                    callback(false);
                } else {
                    showError(_r);
                }
            })
        }
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback() } },
            { key: KBD.ENTER, action: (e) => { selectOption(selected) } },
        ]
        const cleanup = listen(controller, route, actions.concat(menu));
        return cleanup;
    }, [selected]);

    return (
        <div style={{ "width": "500px" }}>
            <div className="shim" /><div className="shim" />
            <Menu controller={controller} callback={(e) => callback(e.sort)} bordered keyName="option" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} /> 
        </div>
    )

}
